<template>
  <validation-provider
    v-slot="{ errors, failed }"
    :name="item.name"
    :rules="validationRules"
  >
    <div
      class="mb-4"
      :class="{'validation-failed':failed}"
    >
      <item-name :item="item" />
      <input
        v-model="value"
        type="text"
        name="postcode"
        class="px-4 py-4 bg-gray-800 text-gray-100 w-full max-w-xs border-3 border-transparent outline-none focus:border-orange-700"
      >
      <item-errors :errors="errors" />
    </div>
  </validation-provider>
</template>

<script>
import ItemMixin from './item-mixin'
import ItemName from './item-name'
import ItemErrors from './item-errors'

export default {
  components: {
    ItemName,
    ItemErrors
  },
  mixins: [ItemMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    validationRules () {
      return {
        required: this.item.meta.required,
        /* TODO: Fixed postcode validator, not triggering on invalid postcode */
        postcode: true
      }
    }
  }
}
</script>
